import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Kratos admin module — `/kratos` on console.francisquini.ai.
 *
 * Single page (runbook dashboard for the Arkheus reconciler — kanban
 * by status + detail drawer). Replaced the original backlog table
 * cockpit; the legacy KratosBacklogPage was deleted in the same PR.
 * Lazy-loaded via the `@/routes/_app/kratos` Suspense shim.
 */
export const manifest: ModuleManifest = {
  module_id: 'kratos',
  display_name: 'Kratos',
  surface: 'admin',
  routes: [
    {
      path: '/kratos',
      component: () =>
        import('@/routes/_app/kratos').then((m) => ({
          default: m.KratosPage,
        })),
      title: 'Kratos',
      permissions: [],
    },
  ],
}
